import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { get } from 'mobx'
import { useRouter } from '@morningtrain/react-navigation'
import { useFieldName } from '@morningtrain/react-fields'

function RouteParameterField ({ name, parameterName }) {
  const router = useRouter()

  const parameters = (router && router.current) ? router.current.parameters : {}

  if (!parameterName) {
    parameterName = name
  }

  const value = get(parameters, parameterName)

  const fieldName = useFieldName(name)

  return (
    <input
      name={fieldName}
      type='hidden'
      value={value}
    />
  )
}

RouteParameterField.propTypes = {
  name: PropTypes.string.isRequired,
  parameterName: PropTypes.string
}

export default observer(RouteParameterField)
